import * as exCollapse from './utils';

// ----------------------------------------------------------------------------

declare global {
    interface HTMLElement {
        showCollapse(config?: Record<string, any>): void;
        hideCollapse(config?: Record<string, any>): void;
        toggleCollapse(config?: Record<string, any>): void;
    }
}

// ----------------------------------------------------------------------------

HTMLElement.prototype.showCollapse = function (config: Record<string, any> = {}): void {
    exCollapse.show(this, config);
};

HTMLElement.prototype.hideCollapse = function (config: Record<string, any> = {}): void {
    exCollapse.hide(this, config);
};

HTMLElement.prototype.toggleCollapse = function (config: Record<string, any> = {}): void {
    exCollapse.toggle(this, config);
};
